// extracted by mini-css-extract-plugin
export default {"card":"SupportContainer_card__xCrN-"};